import React from "react";
import Modal from "react-bootstrap/Modal";

const ChiTietCauHinhGiamTru = ({ data, onClose }) => {
    return (<>
        <Modal
            show={true}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal-new modal fade text-left"
        >
            <Modal.Header style={{ fontWeight: "bold" }}>
                <h4 className="modal-title text-bold" id="myModalLabel16">
                    <span className="btn-icon-right">
                        <i className="mdi mdi-note"></i>
                    </span>
                    <b>Danh sách thuộc tính giảm trừ</b>
                </h4>
                <button
                    type="button"
                    className="close-popup-new"
                    onClick={onClose}
                >
                    <i className="mdi mdi-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <div className="form form-horizontal">
                    <div className="form-body">
                        <div className="form-body">
                            <div className="form-group row " style={{fontWeight:"bold"}}>
                                <label className="col-md-6 label-control text-bold">Tên thuộc tính</label>
                                <label className="col-md-6 label-control text-bold">Giá giảm trừ</label>
                            </div>
                            {data && data.length > 0 && (
                                data.map((item) => (
                                    <div className="form-group row " key={item.ThuocTinhGiamTruId}>
                                        <span class="col-md-6">{item.TenThuocTinh}</span>
                                        <span class="col-md-6">{item.TienGiamTru.toLocaleString("vi-VN")}</span>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer style={{ fontWeight: "bold" }}>
                <button
                    type="button"
                    className="btn btn-new-main btn-closenew"
                    onClick={onClose}
                >
                    <span className="btn-icon-left">
                        <i className="mdi mdi-close"></i>
                    </span>
                    Đóng
                </button>
            </Modal.Footer>
        </Modal>
    </>);
}
export default ChiTietCauHinhGiamTru;